/* Theme-scoped semantics for Judge.me's rendered review widget. */
(() => {
  const connected = new WeakSet();

  function attach(widget) {
    if (connected.has(widget)) return;
    connected.add(widget);
    let previousSignature = null;
    let timer;
    let resetWasActivated = false;
    widget.addEventListener('click', (event) => {
      if (event.target.closest('.jdgm-histogram__clear-filter')) resetWasActivated = true;
    }, true);

    function sync() {
      const rows = widget.querySelectorAll('.jdgm-histogram__row[data-rating]');
      rows.forEach((row) => {
        const control = row.querySelector('.jdgm-histogram__star[role="button"]');
        if (control) {
          control.setAttribute('aria-pressed', String(row.classList.contains('jdgm-histogram__row--selected')));
        }
      });
      const reset = widget.querySelector('.jdgm-histogram__clear-filter');
      if (reset) reset.setAttribute('role', 'button');
      if (resetWasActivated && (!reset || !reset.getClientRects().length)) {
        if (document.activeElement === document.body || document.activeElement === reset) {
          widget.querySelector('.jdgm-sort-dropdown')?.focus({ preventScroll: true });
        }
        resetWasActivated = false;
      }

      const reviews = Array.from(widget.querySelectorAll('.jdgm-rev')).filter((review) =>
        review.getClientRects().length && getComputedStyle(review).display !== 'none'
      );
      if (!reviews.length) return;
      const selected = widget.querySelector('.jdgm-histogram__row--selected');
      const rating = selected?.getAttribute('data-rating');
      const signature = [rating, ...reviews.map((review) => review.textContent.trim())].join('|');
      if (previousSignature !== null && signature !== previousSignature) {
        const status = document.getElementById('status-announcement');
        if (status) {
          status.textContent = `Reviews updated. Showing ${reviews.length} ${reviews.length === 1 ? 'review' : 'reviews'}${rating && rating !== 'null' ? ` with ${rating} stars` : ''}.`;
        }
      }
      previousSignature = signature;
    }

    const observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(sync, 150);
    });
    observer.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    sync();
  }

  function scan(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.matches?.('.jdgm-rev-widg')) attach(root);
    root.querySelectorAll('.jdgm-rev-widg').forEach(attach);
  }

  scan(document);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(scan));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
